var _path, _circle, _circle2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInNothingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    id: "school-accent-4",
    "data-supported-dps": "128x128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e9e5de",
    d: "M0 0h128v128H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 88,
    r: 24,
    fill: "#788fa5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 56,
    r: 40,
    fill: "#9eb3c8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h128v128H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64a24.12 24.12 0 00-6.94 1A40 40 0 0063 94.94 24 24 0 0040 64z",
    fill: "#56687a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInNothingIcon);
export default __webpack_public_path__ + "static/media/LinkedInNothingIcon.d395b5ded9962b45137d0ff71f806585.svg";
export { ForwardRef as ReactComponent };